import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CalendarService } from 'app/modules/calendar/calendar.service';
import { CalendarSettings } from 'app/modules/calendar/calendar.types';

@Injectable({
  providedIn: 'root',
})
export class CalendarSettingsResolver {
  constructor(private _calendarService: CalendarService) {}

  resolve(): Observable<CalendarSettings> {
    return this._calendarService.getSettings();
  }
}
